module.exports = __webpack_public_path__ + "img/activity1.50cce133.png";